/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc>): ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc {
        let obj = Object.assign(new ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc(), model);
        ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc>): ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc {
        if (!model) return null;
        return ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc.newInstance(<ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Organization VDC Id. This is a required field.
     */
    vdc_id: string;

    /**
     * Organization VDC Name. This is a required field.
     */
    vdc_name: string;

}
